import companyService from '../../services/companyService'
import validators from '../validators'
import { PostcodeDistrict } from '@leadgen/models/client'
import { postcodeDistricts } from '../../constants/postcodeDistricts'

class PostcodeDistrictsForm {
  onSubmit = async (values: {
    companyId: string
    postcodeDistricts: PostcodeDistrict[]
  }): Promise<void> => {
    const { companyId, postcodeDistricts } = values
    return companyService.updatePostcodeDistricts({
      companyId,
      postcodeDistricts,
    })
  }
  validatePostcodeDistrictsField = validators.combineValidators(
    validators.validateRequired({
      errorMessage: 'Please enter one or more postcode districts e.g. E17',
    }),
    validators.validateOptionsMulti<PostcodeDistrict>({
      errorMessage: 'Values must be a postcode district',
      options: postcodeDistricts,
    }),
  )
}

export default new PostcodeDistrictsForm()
